// Shared punk image list — all images served as pure static files from /assets/images/
// No proxy, no API route, no external fetch — just direct static file paths

export const LOCAL_PUNK_IMAGES: string[] = [
  '/assets/images/onchain_nodepunks_5720-1789380397040.png',
  '/assets/images/onchain_nodepunks_5631-1789380462383.png',
  '/assets/images/onchain_nodepunks_5692-1789380462925.png',
  '/assets/images/onchain_nodepunks_5680-1789380463891.png',
  '/assets/images/onchain_nodepunks_5718-1789380463455.png',
  '/assets/images/onchain_nodepunks_1574-1789381717284.png',
  '/assets/images/onchain_nodepunks_2720-1789381725643.png',
  '/assets/images/onchain_nodepunks_2653-1789381738391.png',
  '/assets/images/onchain_nodepunks_4563-1789381813374.png',
  '/assets/images/onchain_nodepunks_5720-1789380397040.png',
];

export const LOCAL_FALLBACK = LOCAL_PUNK_IMAGES;
export const DEFAULT_PUNK_IMAGES: string[] = LOCAL_PUNK_IMAGES;

// fetchPunkImages returns local static URLs immediately — no network call needed
export async function fetchPunkImages(): Promise<string[]> {
  return DEFAULT_PUNK_IMAGES;
}

export function getPunkImageUrl(urls: string[], index: number): string {
  const list = urls && urls.length > 0 ? urls : LOCAL_PUNK_IMAGES;
  return list[Math.abs(index) % list.length];
}
